import { whatsappLink } from "@/lib/whatsapp";
import { WhatsAppIcon } from "@/components/common/WhatsAppIcon";

export const WhatsAppFloat = () => (
  <a
    href={whatsappLink()}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with SPC on WhatsApp"
    data-testid="whatsapp-float-button"
    className="group fixed bottom-5 right-5 z-40 flex items-center gap-0 overflow-hidden rounded-none bg-accent p-3.5 text-accent-ink shadow-[0_12px_40px_-12px_rgba(0,0,0,0.45)] transition-[gap,padding,transform] duration-300 hover:-translate-y-0.5 hover:gap-2.5 hover:pr-5 sm:bottom-7 sm:right-7"
  >
    <WhatsAppIcon className="h-6 w-6" />
    <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-medium transition-[max-width] duration-300 group-hover:max-w-[160px]">
      Chat on WhatsApp
    </span>
  </a>
);
